'use strict';

var _jquery = require('jquery');

var _jquery2 = _interopRequireDefault(_jquery);

var _ajax = require('linksoft/utils/ajax');

var _ajax2 = _interopRequireDefault(_ajax);

var _localize = require('linksoft/core/localize');

var _localize2 = _interopRequireDefault(_localize);

var _notify = require('linksoft/notify');

var _notify2 = _interopRequireDefault(_notify);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var resx = (0, _localize2.default)("App", "Common");

(0, _jquery2.default)(document).on('click', '.copy', function () {
    var $this = (0, _jquery2.default)(this);
    var itemId = parseInt($this.attr('data-control-button-copy-select'));
    //TODO: vyčistit select2 a modal jinak
    // pres $("#selectId").select2("val", "") to nejde. Proto odstranovani options
    (0, _jquery2.default)("#select2-applicationId-container").html('<span class=\'select2-selection__placeholder\'>' + resx.App.ChooseApplication + '</span>');
    (0, _jquery2.default)('#applicationId').find('option').remove().end();
    (0, _jquery2.default)("#copy-result").html('');
    (0, _jquery2.default)('[data-copy-item-id]').attr("data-copy-item-id", itemId);
});

(0, _jquery2.default)('[data-copy-submit]').off('click').on('click', function () {
    var postUrl = getPostUrl((0, _jquery2.default)('[data-copy-item-id]'));
    var applicationId = (0, _jquery2.default)('#applicationId').val();
    if (!applicationId) {
        (0, _jquery2.default)("#copy-result").html('<i class="fa fa-exclamation-triangle red" aria-hidden="true"></i> ' + resx.App.ChooseApplication);
        return;
    }
    var api = (0, _jquery2.default)(".copy").closest(".dataTable").DataTable();

    (0, _ajax2.default)({
        url: postUrl,
        method: 'POST',
        contentType: "application/json",
        data: JSON.stringify({ "applicationId": applicationId })
    }).done(function (result) {
        (0, _jquery2.default)("#applicationId").select2("val", "");
        //TODO: vyčistit select2 jinak
        (0, _jquery2.default)("#select2-applicationId-container").html('<span class=\'select2-selection__placeholder\'>' + resx.App.ChooseApplication + '</span>');
        (0, _jquery2.default)('#applicationId').find('option').remove().end();
        (0, _jquery2.default)("#copy-result").html('<i class="fa fa-check-circle green"></i> ' + resx.Common.Item + ' ' + resx.App.WasCopiedToApplication);
        _notify2.default.success(resx.Common.UpdateCopySuccess);
        api.ajax.reload(null, false);
    }).fail(function (result) {
        console.log(result);
        (0, _jquery2.default)("#copy-result").html('<i class="fa fa-exclamation-triangle red"></i> ' + resx.Common.Item + ' ' + resx.App.WasNotCopiedToApplication);
        _notify2.default.error(resx.Common.UpdateCopyFail);
    });
});

(0, _jquery2.default)('[data-copy-watchdogs]').off('click').on('click', function () {
    var postUrl = getPostUrl((0, _jquery2.default)('[data-copy-item-id]'));
    var productId = (0, _jquery2.default)('#productId').val();

    if (!productId) {
        (0, _jquery2.default)("#copy-result").html('<i class="fa fa-exclamation-triangle red" aria-hidden="true"></i> ' + resx.App.ChooseProduct);
        return;
    }
    var api = (0, _jquery2.default)(".copy").closest(".dataTable").DataTable();

    (0, _ajax2.default)({
        url: postUrl,
        method: 'POST',
        contentType: "application/json",
        data: JSON.stringify({ "productId": productId })
    }).done(function (result) {
        (0, _jquery2.default)("#productId").select2("val", "");
        (0, _jquery2.default)("#select2-productId-container").html('<span class=\'select2-selection__placeholder\'>' + resx.App.ChooseProduct + '</span>');
        (0, _jquery2.default)('#productId').find('option').remove().end();
        (0, _jquery2.default)("#copy-result").html('<i class="fa fa-check-circle green"></i> ' + resx.App.WatchdogsCopy + ' do ' + result.value);
        _notify2.default.success(resx.Common.UpdateCopySuccess);
        api.ajax.reload(null, false);
    }).fail(function (result) {
        console.log(result);
        _notify2.default.error(resx.Common.UpdateCopyFail);
    });
});

var getPostUrl = function getPostUrl(element) {
    var itemId = element.attr("data-copy-item-id");
    var controller = location.href.split('/')[3];
    var postUrl = location.protocol + '//' + location.host + '/odata/' + controller + '(' + itemId + ')/Default.Clone';
    return postUrl;
};

(0, _jquery2.default)(document).on('click', '.dataTable [control-button-delete]', function () {
    var $deleteBtn = (0, _jquery2.default)(this);
    var itemId = $deleteBtn.attr('control-button-delete');
    if (!itemId) return;
    var $table = $deleteBtn.closest('.dataTable');
    if ($table.length > 0) {
        var api = $table.DataTable();
        var url = api.init().ajax.url;
        var deleteUrl = url + '(' + itemId + ')';
        (0, _ajax2.default)({ url: deleteUrl, method: 'DELETE' }).done(function (result) {
            _notify2.default.success(resx.Common.DeleteSuccess);
            api.ajax.reload(null, false);
        }).fail(function (result) {
            _notify2.default.error(resx.Common.AjaxError);
        });
    }
});

(0, _jquery2.default)(document).on('click', '.dataTable [data-control-button-filemanager-delete]', function () {
    var $deleteBtn = (0, _jquery2.default)(this);
    var itemId = $deleteBtn.data('control-button-filemanager-delete');
    var type = $deleteBtn.data('control-button-filemanager-delete-type');
    if (!itemId) return;
    var $table = $deleteBtn.closest('.dataTable');
    if ($table.length > 0) {

        var api = $table.DataTable();
        // split to remove possible query parameters 
        var url = api.init().ajax.url.split('?')[0];
        var deleteUrl = url + '(' + itemId + ')?type=' + type;
        (0, _ajax2.default)({ url: deleteUrl, method: 'DELETE' }).done(function (result) {
            _notify2.default.success(resx.Common.DeleteSuccess);
            api.ajax.reload(null, false);
        }).fail(function (result) {
            _notify2.default.error(resx.Common.AjaxError);
        });
    }
});

(0, _jquery2.default)(document).on('click', '.dataTable [data-control-button-is-active]', function () {
    var $btn = (0, _jquery2.default)(this);
    var itemId = $btn.attr('data-control-button-is-active-item-id');
    var isActive = $btn.attr('data-control-button-is-active') === 'true';
    if (!itemId) return false;
    var $table = $btn.closest('.dataTable');
    if ($table.length > 0) {
        var api = $table.DataTable();
        var url = correctUrl(api.init().ajax.url);
        var patchUrl = url + '(' + itemId + ')';
        (0, _ajax2.default)({
            url: patchUrl, method: 'PATCH', data: JSON.stringify({ "isActive": !isActive }),
            contentType: 'application/json; charset=UTF-8'
        }).done(function (result) {
            _notify2.default.success(resx.Common.UpdateSuccess);
            api.ajax.reload(null, false);
        }).fail(function (result) {
            var msg = getBadRequestErrorMessage(result);
            _notify2.default.error(msg);
            api.ajax.reload(null, false);
        });
    }
    return false;
});

(0, _jquery2.default)(document).on('click', '.dataTable [data-control-switch-user-visibility-id]', function () {
    var $btn = (0, _jquery2.default)(this);
    var itemId = $btn.attr('data-control-switch-user-visibility-id');

    if (!itemId) return false;

    var isAnonymous = $btn.attr('data-control-isAnonymous') == "true";
    var isLogged = $btn.attr('data-control-isLogged') == "true";
    var userVisibilityType = parseInt($btn.attr('data-control-type'));

    var $table = $btn.closest('.dataTable');

    if ($table.length > 0) {
        var api = $table.DataTable();
        var url = correctUrl(api.init().ajax.url);
        var patchUrl = url + '(' + itemId + ')';

        var setIsLogged = userVisibilityType == 1 ? !isLogged : isLogged;
        var setIsAnonymous = userVisibilityType == 2 ? !isAnonymous : isAnonymous;

        (0, _ajax2.default)({
            url: patchUrl, method: 'PATCH', data: JSON.stringify({
                "isLogged": setIsLogged,
                "isAnonymous": setIsAnonymous
            }),
            contentType: 'application/json; charset=UTF-8'
        }).done(function (result) {
            _notify2.default.success(resx.Common.UpdateSuccess);
            api.ajax.reload(null, false);
        }).fail(function (result) {
            var msg = getBadRequestErrorMessage(result);
            _notify2.default.error(msg);
            api.ajax.reload(null, false);
        });
    }
});

(0, _jquery2.default)(document).on('click', '.dataTable [data-control-switch-id]', function () {
    var $btn = (0, _jquery2.default)(this);
    var itemId = $btn.attr('data-control-switch-id');

    if (!itemId) return false;

    var propertyName = $btn.attr('data-control-name');
    var value = $btn.attr('data-control-value') == "true";

    var $table = $btn.closest('.dataTable');

    if ($table.length > 0) {
        var api = $table.DataTable();
        var url = correctUrl(api.init().ajax.url);
        var patchUrl = url + '(' + itemId + ')';

        var data = {};
        data[propertyName] = !value;

        (0, _ajax2.default)({
            url: patchUrl, method: 'PATCH', data: JSON.stringify(data),
            contentType: 'application/json; charset=UTF-8'
        }).done(function (result) {
            _notify2.default.success(resx.Common.UpdateSuccess);
            api.ajax.reload(null, false);
        }).fail(function (result) {
            var msg = getBadRequestErrorMessage(result);
            _notify2.default.error(msg);
            api.ajax.reload(null, false);
        });
    }
});

(0, _jquery2.default)(document).on('click', '.dataTable [data-control-button-copy]', function () {
    var $btn = (0, _jquery2.default)(this);
    var itemId = $btn.attr('data-control-button-copy');
    if (!itemId) return;
    var $table = $btn.closest('.dataTable');
    if ($table.length > 0) {
        var api = $table.DataTable();
        var url = correctUrl(api.init().ajax.url);
        var postUrl = url + '(' + itemId + ')/Default.Clone';
        (0, _ajax2.default)({
            url: postUrl,
            method: 'POST',
            contentType: "application/json"
        }).done(function (result) {
            _notify2.default.success(resx.Common.UpdateCopySuccess);
            api.ajax.reload(null, false);
        }).fail(function (result) {
            console.log(result);
            _notify2.default.error(resx.Common.UpdateCopyFail);
        });
    }
});

(0, _jquery2.default)(document).on('click', '.dataTable [data-control-button-delete]', function () {
    var $deleteBtn = (0, _jquery2.default)(this);
    var itemId = $deleteBtn.attr('data-control-button-delete');
    var deleteUrlTail = $deleteBtn.attr('data-delete-url');
    if (!itemId) return;
    var $table = $deleteBtn.closest('.dataTable');
    if ($table.length > 0) {
        var api = $table.DataTable();
        var deleteUrl = !!deleteUrlTail ? window.location.origin + '/' + deleteUrlTail.replace('{id}', itemId) : correctUrl(api.init().ajax.url) + '(' + itemId + ')';

        (0, _ajax2.default)({ url: deleteUrl, method: 'DELETE' }).done(function (result) {
            _notify2.default.success(resx.Common.DeleteSuccess);
            api.ajax.reload(null, false);
        });
    }
});

(0, _jquery2.default)(document).on('click', '.dataTable [data-control-button-undo-expired-order]', function () {
    var $btn = (0, _jquery2.default)(this);
    var itemId = $btn.attr("data-control-button-undo-expired-order");

    if (!itemId) return;

    var $table = $btn.closest('.dataTable');

    if ($table.length > 0) {

        var api = $table.DataTable();
        var url = correctUrl(api.init().ajax.url);
        var patchUrl = url + '(' + itemId + ')';

        (0, _ajax2.default)({
            url: patchUrl, method: 'PATCH'
        }).done(function (result) {
            _notify2.default.success(resx.Common.UpdateSuccess);
            api.ajax.reload(null, false);
        }).fail(function (result) {
            var msg = getBadRequestErrorMessage(result);
            _notify2.default.error(msg);
            api.ajax.reload(null, false);
        });
    }
    return false;
});

var correctUrl = function correctUrl(url) {
    var correctUrl = url;
    if (url.indexOf('?') > -1) {
        correctUrl = url.substring(0, url.indexOf('?'));
    }
    return correctUrl;
};

var getBadRequestErrorMessage = function getBadRequestErrorMessage(response) {
    var jsonResponse;
    if (response.responseText) {
        jsonResponse = JSON.parse(response.responseText);
        if (jsonResponse.error && jsonResponse.error.message) {
            return jsonResponse.error.message;
        }
    }
    return resx.Common.AjaxError;
};


//////////////////
// WEBPACK FOOTER
// ./Scripts/app/dt-control-buttons.js
// module id = 428
// module chunks = 0